// extracted by mini-css-extract-plugin
module.exports = {"main_page":"MainPage_main_page__3R_bw","colored":"MainPage_colored__34g3j"};